import Uppy from '@uppy/core';
import ptBR from '@uppy/locales/lib/pt_BR';
import UppyDashboard from '@uppy/dashboard';
import UppyXHRUpload from '@uppy/xhr-upload';
import UppyWebcam from '@uppy/webcam';
import eventos from '@/common/eventos';
import forms from '@/common/forms';

import '@uppy/core/dist/style.min.css';
import '@uppy/dashboard/dist/style.css';
import '@uppy/webcam/dist/style.css';


// configure the class for runtime loading
if (!window.fbControls) window.fbControls = [];
window.fbControls.push(function (controlClass) {

    class uppyPictureUpload extends controlClass {

        /**
         * Class configuration - return the icons & label related to this control
         * @returndefinition object
         */
        static get definition() {
            return {
                icon: '📸',
                i18n: {
                    default: 'Upload de fotos'
                }
            };
        }

        /**
         * javascript & css to load
         */
        configure() {
        }

        /**
         * build a text DOM element, supporting other jquery text form-control's
         * @return {Object} DOM Element to be injected into the form.
         */
        build() {
            return this.markup('span', null, {id: this.config.name});
        }

        /**
         * onRender callback
         */
        onRender() {
            let fotosSalvas = forms.getQuantidadeFotosSalvas();
            let uppy = Uppy({
                locale: ptBR,
                restrictions: {
                    allowedFileTypes: ['image/*'],
                    minNumberOfFiles: this.config.required ? Math.max(0, this.config.minFiles - fotosSalvas) : 0,
                    maxNumberOfFiles: (this.config.maxFiles - fotosSalvas || -1),
                    maxFileSize: 1e+7 // 10MB
                }
            });
            uppy.use(UppyXHRUpload);
            uppy.use(UppyWebcam, {
                facingMode: 'environment',
                modes: ['picture']
            });
            uppy.use(UppyDashboard,
                {
                    target: '#' + this.config.name,
                    inline: true,
                    hideUploadButton: true,
                    hideRetryButton: true,
                    hideCancelButton: true,
                    proudlyDisplayPoweredByUppy: false,
                    plugins: ['Webcam']
                });
            eventos.barramento.$emit(eventos.UPPY_CRIADO, uppy);
        }
    }

    controlClass.register('uppypicture', uppyPictureUpload);
    return uppyPictureUpload;
});
